import React, { createRef, useEffect, useState } from 'react'
import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Divider,
  Checkbox,
  message,
  Modal,
  Input,
  Dropdown,
  Menu,
  Switch,
  Spin,
} from 'antd'
import { connect, useDispatch } from 'react-redux'

import './index.scss'
import { getCurrentCompany } from '../../../../services/user'
import TableComponent from 'components/Table'
import { Spinner } from 'constants/constants'
import SelectField from 'components/SelectField'
import SearchableColumn from 'components/Table/ColumnSearch'
import CustomTooltip from 'components/Tooltip'
import { addStr, dateFormatter, financial } from '../../../../services/helper'
import {
  AccountDetailsIco,
  AccountExtractIco,
  AccountMoreIco,
  ArrowDownIco,
  ArrowUpIco,
  CardBlocked,
  LimitlerIco,
  ModalCloseIco,
  ModalErrorIco,
  NewTransferIco,
  PdfIco,
  ReloadIco2,
  ResetPinTrying,
  SmsIco,
  SmsInfo,
  TabsInfoIco,
  TeslifatIcon,
  TransfersIco,
  UpdateLimitIco,
} from '../../../../../modules/CustomIcons'
import Icon, { InfoCircleOutlined, ReloadOutlined } from '@ant-design/icons'
import SortableColumn from 'components/Table/ColumnSort'
import { Link } from 'react-router-dom'
import visa_card from '../../../../../assets/images/visa_card.png'
import master_card from '../../../../../assets/images/master_card.png'
import {
  getNewCards,
  NewCards,
  getNewCardBalance,
  getNewCardLimit,
} from '../../../../services/BrCards/NewCards'
import EnableOrDisableServiceModal from 'components/EnableOrDisableServiceModal'
import { updateAccountNickname } from '../../../../services/Accounts/AccountNickname'
import { getOldCards } from '../../../../services/BrCards/OldCards'
// import { getOldCardBalance, getOldCardLimit } from "../../../../services/BrCards/OldCards";
import { useTranslation } from 'react-i18next'
import {
  getAccountsData,
  getBlockedIbanData,
  getRequisiteData,
  setIbanNumber,
  setMoreDetail,
} from 'store/actions/accountStatement'
import { useActions } from 'hooks/useActions'
import NextModal from 'components/NextModalAccount'
import { footerBtnsSecondModal } from 'pages/Transfers/StatusRender'
import { getRequisitePDFfile } from '../../../../services/account'
import FullScreenLoading from 'components/FullScreenLoading'
import LimitsModalMain from '../LimitsPage'
import BlockedCardSwitch from '../LimitsPage/blocks/limitAndBlockCardPage/blockCardModal'
import { resetEmployeePan, setPan } from 'store/reducers/limitsforBusinnesCard/employeePan'
import CustomResult from '../LimitsPage/utils/CustomResult'
import { limitsCardApi, useFetchCardLimitsQuery } from 'store/reducers/limitsforBusinnesCard/cardLimits.api'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { useAbility } from '@shared/AccessManager'

const VoenCard: React.FC<any> = (props: any) => {
  const { requisiteData } = props
  const { t } = useTranslation()
  const ability = useAbility()

  const dispatch = useDispatch();

  const statusList = [
    {
      value: 'all',
      label: t('common.all'),
    },
    {
      value: 'Active',
      label: t('salary.active'),
    },
    {
      value: 'Blocked',
      label: t('home.blocked'),
    },
    {
      value: 'Deactive',
      label: t('businessCards.deactive'),
    },
  ]
  const [tableLoading, setTableLoading] = useState(Spinner)
  const [tableDataMain, setTableDataMain] = useState()
  const [tableData, setTableData] = useState()
  const [tableDataForSort, setTableDataForSort] = useState()
  const [expandedRowKeys, setExpandedRowKeys] = useState<any>([])
  const [enableOrDisableSmsNotif, setEnableOrDisableSmsNotif] =
    useState<boolean>(false)
  const [visibleBlockUnblockCardModal, setVisibleBlockUnblockCardModal] =
    useState<boolean>(false)
  const [visibleResetPinModal, setVisibleResetPinModal] =
    useState<boolean>(false)
  const [visibleSmsNotifModal, setVisibleSmsNotifModal] =
    useState<boolean>(false)
  const [accountSelectedRow, setAccountSelectedRow] = useState<any>()
  const [cardSelectedRow, setCardSelectedRow] = useState<any>()
  const [form] = Form.useForm()
  const [titleRequisiteState, setTitleRequisiteState] = useState<Array<any>>([])
  const [requisiteModalVisible, setRequisiteModalVisible] = useState(false)
  const [exportDetail, setExportDetail] = useState<any>([false, false])
  const [isLoading, setIsLoading] = useState(false);
  const [filtereValuesSubCard, setFilteredValuesSubCard] = useState<any>([])
  const { setMoreDetail, getRequisiteData } = useActions()
  const [openModal, setOpenModal] = useState(false)
  const [openBlockedModal, setOpenBlockedModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState({
    modalStatus:false,
    modalErrorMessage: ''
  })

  const pan = useAppSelector((state) => state.employeePan.pan)

  const { isFetching, isError, error } = useFetchCardLimitsQuery(pan, {
      skip: !pan,
    })
    
  const toggleMoreTable = (record) => {
    let key = record.key,
      check_index = expandedRowKeys.indexOf(key)

    if (check_index === -1) {
      setExpandedRowKeys((old_array) => [...expandedRowKeys, key])
    } else {
      expandedRowKeys.splice(check_index, 1)

      setExpandedRowKeys((old_array) => [...expandedRowKeys])
    }
  }

  const exportRequisitePDF = async (selectedvalue: any) => {
    let newExportDedatil = [...exportDetail]
    newExportDedatil[0] = true
    setExportDetail(newExportDedatil)

    const formData = {
      ibanRef: requisiteData?.rekvizitAzn
        ? requisiteData?.rekvizitAzn[0]?.iban
        : '',
    }
    const data = await getRequisitePDFfile(formData, selectedvalue)
    downloadPDF(
      data?.data.fileDetailsList[0].fileName,
      data?.data.fileDetailsList[0].fileBase64
    )

    newExportDedatil = [...exportDetail]
    newExportDedatil[0] = false
    setExportDetail(newExportDedatil)
  }

  function downloadPDF(fileName: string, fileBase64: string) {
    const linkSource = `data:application/pdf;base64,${fileBase64}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }
  const sendFunc = () => {
    // console.log("export1")
  }

  const footerBtnsSecondModal = [
    {
      icon: <PdfIco />,
      title: '',
      key: 'pdf',
      loading: exportDetail[0],
      onClickFunc: exportRequisitePDF,
      disabled: false,
    },
    {
      icon: <SmsIco />,
      title: '',
      key: 'sms',
      loading: exportDetail[1],
      onClickFunc: sendFunc,
      disabled: true,
    },
  ]
  const enableOrDisableSmsNotification = () => {
    setEnableOrDisableSmsNotif((old_data) => true)
    setVisibleSmsNotifModal((old_data) => true)
  }
  const sendMoreDetailFunc = (key: string, iban: string, from: string) => {
    setMoreDetail({ key: key, iban: iban, from: from })
  }

  const openRequisite = (record: any) => {
    const titleRequisite = [
      record.col_1.title,
      record.col_7.card_balance,
      record.col_6.card_currency,
    ]
    //
    setTitleRequisiteState(titleRequisite)
    getRequisiteData({
      company: getCurrentCompany(),
      ibanRef: record.col_1.subtitle,
    })

    setRequisiteModalVisible((old_data) => true)
  }

  const controlDropdownMenu = () => {
    // const newData = [...tableData];
    // if(newData !== undefined) {
    //     newData?.map((item: any) => {
    //         item.isDropdown = false
    //     })
    // }
    // setTableData(newData)
  }
  const handleModalClose = () => {
    setRequisiteModalVisible(false)
  }

  const accountDropDown = (record: any) => (
    <Menu className="hesablar_dropdown business_cards_dropdown ">
      <Menu.Item icon={<Icon component={() => <AccountDetailsIco />} />}>
        <Link
          onClick={(e) => {
            openRequisite(record)
            controlDropdownMenu()
            return false
          }}
          to={'#'}
        >
          {t('requisites.accountDetails')}
        </Link>
      </Menu.Item>

      <Menu.Item
        onClick={() => {
          sendMoreDetailFunc(record.key, record.col_1.subtitle, 'tefsilat')
        }}
        icon={<Icon component={() => <TeslifatIcon />} />}
      >
        <Link to={'/accounts/accounts'}>{t('home.details')}</Link>
      </Menu.Item>

      <Menu.Item
        className={''}
        icon={<Icon component={() => <AccountExtractIco />} />}
      >
        <Link
          to={{
            pathname: '/business_cards/card_account_statement',
            state: { iban: accountSelectedRow?.Iban },
          }}
        >
          {t('businessCards.cardAccountStatement')}
        </Link>
      </Menu.Item>
    </Menu>
  )


  const getLimitsInfo = (pan: string) => {
    setOpenModal(true)
    dispatch(setPan({ pan }))
  }
  const getLimitsInfoForBlockCard = (pan: string) => {
    setOpenBlockedModal(true)
    dispatch(setPan({ pan }))
  }

  const cardDropDown = (record: any) => (
    <Menu className="hesablar_dropdown business_cards_dropdown ">
      {/* <Menu.Item icon={<Icon component={() => <AccountDetailsIco />} />}>
        <Link
          onClick={(e) => {
            openRequisite(accountSelectedRow)
            controlDropdownMenu()
            return false
          }}
          to={'#'}
        >
          {t('requisites.accountDetails')}
        </Link>
      </Menu.Item> */}
{/* 
      <Menu.Item
        onClick={() => {
          sendMoreDetailFunc(
            accountSelectedRow.key,
            accountSelectedRow.col_1.subtitle,
            'tefsilat'
          )
        }}
        icon={<Icon component={() => <TeslifatIcon />} />}
      >
        <Link to={'/accounts/accounts'}>{t('home.details')}</Link>
      </Menu.Item> */}

      <Menu.Item
        className={''}
        icon={<Icon component={() => <AccountExtractIco />} />}
      >
        <Link
          to={{
            pathname: '/business_cards/card_account_statement',
            state: { iban: accountSelectedRow?.key },
          }}
        >
          {t('businessCards.cardAccountStatement')}
        </Link>
      </Menu.Item>

      <Menu.Item
        className={''}
        icon={<Icon component={() => <AccountExtractIco />} />}
      >
        <Link
          to={{
            pathname: '/business_cards/card_accountpan_statement',
            state: { card: record?.col_2 },
          }}
        >
          {t('businessCards.cardStatement')}
        </Link>
      </Menu.Item>

      <Divider />

      {
        ability.can('view', 'BusinessCardLimit') && (<Menu.Item
          className={''}
          onClick={() => getLimitsInfo(record?.col_2?.card_number)}
          icon={<Icon component={() => <LimitlerIco />} />}
        >
          {t('businessCards.limits')}
          <span style={{ overflow: 'visible' }}>
            <div
              style={{
                display: 'inline-block',
                position: 'relative',
                right: '-6px',
                zIndex: '1000000 !important',
              }}
            >
              <span className="hopword">new</span>
            </div>
          </span>
        </Menu.Item>)
      }

      {
        ability.can('view', 'BusinessCardBlock') && (
          <Menu.Item
            className={''}
            // onClick={(e) => setVisibleBlockUnblockCardModal(old_data => true)} if dont used deleted this code
            onClick={() => getLimitsInfoForBlockCard(record?.col_2?.card_number)}
            icon={<Icon component={() => <CardBlocked />} />}
          >
            {t('businessCards.blockCard')}
            <span style={{ overflow: 'visible' }}>
              <div
                style={{
                  display: 'inline-block',
                  position: 'relative',
                  right: '-6px',
                  zIndex: '1000000 !important',
                }}
              >
                <span className="hopword">new</span>
              </div>
            </span>
          </Menu.Item>
        )
      }

      <Menu.Item
        className={'is_disabled'}
        // onClick={(e) => setVisibleResetPinModal(old_data => true)}
        icon={<Icon component={() => <ResetPinTrying />} />}
      >
        {t('businessCards.resetPINEntryAttempt')}
      </Menu.Item>

      <Menu.Item
        className={'is_disabled flex align_center justify_between'}
        icon={<Icon component={() => <SmsInfo />} />}
      >
        <p className={'flex align_center'}>
          {t('businessCards.SMSNotification')}

          <CustomTooltip title={t('businessCards.SMSNotificationDescription')}>
            <Button
              type={'ghost'}
              className={'trasparent info_icon'}
              icon={<TabsInfoIco />}
            />
          </CustomTooltip>
        </p>

        <Switch
          checked={enableOrDisableSmsNotif}
          // onChange={enableOrDisableSmsNotification}
        />
      </Menu.Item>

      {/* <Menu.Item icon={<Icon component={() => (<AccountExtractIco  />)} />}>
                {t("businessCards.cardAccountStatement")}
            </Menu.Item>

            <Menu.Item icon={<Icon component={() => (<AccountExtractIco  />)} />}>
                {t("businessCards.cardStatement")}
            </Menu.Item>


            <Divider />

            <Menu.Item className={`${cardSelectedRow?.row.monthly_limit==='-' ? 'is_disabled' : '' }`} icon={<Icon component={() => (<LimitlerIco   />)} />}>
                {t("businessCards.limits")}
            </Menu.Item>

            <Menu.Item onClick={(e) => setVisibleBlockUnblockCardModal(old_data => true)} icon={<Icon component={() => (<CardBlocked  />)} />}>
                {t("businessCards.blockCard")}
            </Menu.Item>

            <Menu.Item  onClick={(e) => setVisibleResetPinModal(old_data => true)} icon={<Icon component={() => (<ResetPinTrying  />)} />}>
                {t("businessCards.resetPINEntryAttempt")}
            </Menu.Item>

            <Menu.Item className={'flex align_center justify_between'} icon={<Icon component={() => (<SmsInfo  />)} />}>
                <p className={'flex align_center'} >
                    {t("businessCards.SMSNotification")}

                    <CustomTooltip title={t("businessCards.SMSNotificationDescription")} >
                        <Button type={"ghost"} className={'trasparent info_icon'} icon={<TabsInfoIco />} />
                    </CustomTooltip>

                </p>

                <Switch checked={enableOrDisableSmsNotif} onChange={enableOrDisableSmsNotification} />
            </Menu.Item>*/}
    </Menu>
  )

  const accountTableColumns = [
    {
      title: (
        <>
          <div>{t('businessCards.accountName')}</div>
        </>
      ),
      dataIndex: 'col_1',
      key: 'col_1',
      className: 'col_1 ant-table-cell-ellipsis',
      render: (data) => (
        <>
          {/*<CustomTooltip title={data.tooltip}  >*/}
          <p className=" align_center not_open_popup">
            <div
              className={
                'not_open_popup account_edit_nickname account_searchable'
              }
            >
              <Form form={form}>
                <SearchableColumn
                  large
                  title={data.title}
                  allowSearch={false}
                  customIcon={true}
                  form={form}
                  allowClear={true}
                  value={data.title}
                  name={'updateAccountName1'}
                  /*onChange={(e) => updateAccountName(e, data.subtitle)}*/
                  onBlur={(e) => updateAccountName(e, data)}
                />
              </Form>
            </div>
          </p>
          {/*</CustomTooltip>*/}
          <span className="business_card_iban">{data.subtitle}</span>
        </>
      ),
      ellipsis: true,
      width: 103,
    },
    // {
    //     title: (
    //         <>
    //             <div>
    //                 {t("businessCards.accountName")}
    //             </div>
    //         </>
    //     ),
    //     dataIndex: 'col_1',
    //     key: 'col_1',
    //     className: 'col_1 ant-table-cell-ellipsis',
    //     render: data => (
    //         <>
    //             <Form
    //                 form={form}
    //             >
    //                 <p className=' align_center not_open_popup is_blue'>
    //                     <div className={'not_open_popup account_edit_nickname account_searchable'} >
    //                         <SearchableColumn
    //                             large
    //                             title={data.title}
    //                             customIcon={true}
    //                             allowClear={true}
    //                             onBlur={(e) => updateAccountName(e, data)}
    //                         />
    //                     </div>
    //                 </p>
    //             </Form>
    //         </>
    //     ),
    //     ellipsis: true,
    //     width: 103,
    // },
    {
      title: (
        <div style={{ textAlign: 'left' }}>{t('businessCards.countsCard')}</div>
      ),
      dataIndex: 'col_2',
      key: 'col_2',
      className: ' col_2',
      ellipsis: true,
      width: 130,
      editable: false,
      render: (data, record, index) => {
        return (
          <div className={'flex align_center full_h'}>
            {data.card_count > 0 && (
              <Button
                type={'ghost'}
                icon={
                  expandedRowKeys.indexOf(record.key) !== -1 ? (
                    <ArrowUpIco />
                  ) : (
                    <ArrowDownIco />
                  )
                }
                className={'show_card_count_btn show_card_count_btn2'}
                onClick={() => {
                  toggleMoreTable(record)
                  setAccountSelectedRow(record)
                }}
              >
                {data.card_count}
              </Button>
            )}
            {
              ability.can('view', 'NewIcon') && (<sup>
                <div
                  style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: '#F3646C',
                    marginLeft: '4px',
                  }}
                ></div>
              </sup>)
            }
          </div>
        )
      },
    },
    {
      title: <div>{t('businessCards.cardAccountIBAN')}</div>,
      dataIndex: 'col_3',
      key: 'col_3',
      className: ' col_3',
      ellipsis: true,
      width: 130,
      editable: false,
      render: (text) => {
        return <p>{text.card_number}</p>
      },
    },
    {
      title: <div>{t('credits.creditStatus')}</div>,
      dataIndex: 'col_4',
      key: 'col_4',
      className: 'col_4',
      ellipsis: true,
      width: 230,
      editable: false,
      render: (text) => {
        let p_classname = text.card_blocked
          ? 'has_blocked_amount'
          : 'no_blocked_amount'

        return (
          <>
            <p className={p_classname}>{text.card_status}</p>
            {/*{
                            text.card_blocked && <CustomTooltip title={text.tooltip}>
                                <Button className='has_blocked_data transparent' icon={<InfoCircleOutlined /> }  />
                            </CustomTooltip>
                        }*/}
          </>
        )
      },
    },
    {
      title: <div className="sort_col">{t('businessCards.openingDate')}</div>,
      dataIndex: 'col_5',
      key: 'col_5',
      className: 'col_5',
      ellipsis: true,
      width: 250,
      editable: false,
      render: (text) => {
        let expire_date = dateFormatter(
          text.card_expire_date,
          'MMMM DD, YYYY HH:mm:ss',
          'DD.MM.YYYY'
        )
        let p_class = ''

        if (new Date(expire_date) < new Date()) {
          p_class = ' card_expired '
        } else if (
          parseInt(dateFormatter(text.card_expire_date, 'M', 'DD.MM.YYYY')) ===
            new Date().getMonth() + 1 &&
          parseInt(
            dateFormatter(text.card_expire_date, 'YYYY', 'DD.MM.YYYY')
          ) === new Date().getFullYear()
        ) {
          p_class = ' card_expired_this_month '
        }

        return <p>{text.card_expire_date}</p>
      },
    },
    {
      title: (
        <div className="required-column sort_col">
          <span>{t('home.currency')}</span>
        </div>
      ),
      dataIndex: 'col_6',
      key: 'col_6',
      className: 'col_6',
      ellipsis: true,
      width: 209,
      editable: false,
      render: (text) => {
        return <p>{text.card_currency}</p>
      },
    },
    {
      title: (
        <div className="flex align_center full justify_end sort_col">
          {t('home.balance')}
        </div>
      ),
      dataIndex: 'col_7',
      key: 'col_7',
      className: 'col_7',
      ellipsis: true,
      width: 100,
      editable: false,
      render: (text, record) => (
        <p
          className={
            parseFloat(text.card_balance) > 0 ? 'has_balance' : 'no_balance'
          }
        >
          {text.card_balance}
        </p>
      ),
    },
    {
      title: (
        <CustomTooltip title={t('businessCards.updateAllBalances')}>
          <Button
            icon={<ReloadIco2 />}
            onClick={() => updateBalance('allBalance')}
            className="transparent box_reload_ico reload_all_balance_btn"
          />
        </CustomTooltip>
      ),
      dataIndex: 'col_8',
      key: 'col_8',
      className: 'col_8',
      ellipsis: true,
      width: 100,
      editable: false,
      render: (text, record) => (
        <div className="flex align_center justify_end account_operation_table_button btn_box">
          <CustomTooltip title={t('businessCards.updateBalance')}>
            <Button
              icon={<ReloadIco2 />}
              onClick={() => updateBalance(record.row)}
              className="transparent box_reload_ico"
            />
          </CustomTooltip>
        </div>
      ),
    },
    {
      title: '',
      dataIndex: 'col_9',
      key: 'col_9',
      className: 'col_9 dropdown_3dot',
      ellipsis: true,
      width: 100,
      editable: false,
      render: (text, record) => (
        <div className={'btn_box flex align_center justify_center'}>
          {record.row.MainStatus === 'Esas' && (
            <Dropdown
              overlay={() => accountDropDown(record)}
              trigger={'click'}
              placement="bottomRight"
            >
              <Button
                icon={<AccountMoreIco />}
                onClick={(e) => {
                  setAccountSelectedRow((old_data) => record.row)
                }}
                className="transparent table_more_btn"
              />
            </Dropdown>
          )}
        </div>
      ),
    },
  ]

  const expandedRowRender = () => {
    const columns = (ind, recordData) => [
      {
        title: (
          <Form form={form}>
            <SearchableColumn
              divClass={'search_type_2'}
              title={t('businessCards.cardName')}
              name={'card_name' + ind}
              onChange={(event: any) => filterSubCard(event, 'card_name', ind)}
              form={form}
              filter={'searchfilter'}
            />
          </Form>
        ),
        dataIndex: 'col_1',
        key: 'col_1',
        className: 'col_1 ant-table-cell-ellipsis',
        render: (data, alldata) => (
          <>
            <CustomTooltip title={data.title}>
              {/*<p className={'text-right'}>{data.title}</p>*/}
              <p className=" align_center not_open_popup">
                <div
                  className={
                    'not_open_popup account_edit_nickname account_searchable1'
                  }
                >
                  <Form form={form}>
                    <SearchableColumn
                      large
                      title={data.title}
                      // customIcon={true}
                      form={form}
                      allowClear={true}
                      value={data.title}
                      nickname={alldata.nickname}
                      name={'updateAccountNameAdd'}
                      /*onChange={(e) => updateAccountName(e, data.subtitle)}*/
                      onBlur={(e) => updateAccountName(e, data)}
                    />
                  </Form>
                </div>
              </p>
            </CustomTooltip>
          </>
        ),
        ellipsis: true,
        width: 103,
      },
      {
        title: (
          <Form form={form}>
            <SearchableColumn
              divClass={'search_type_2'}
              title={t('businessCards.additionalCardsPAN')}
              name={'card_pan' + ind}
              onChange={(event: any) => filterSubCard(event, 'card_pan', ind)}
              form={form}
              filter={'searchfilter'}
            />
          </Form>
        ),
        dataIndex: 'col_2',
        key: 'col_2',
        className: ' col_2',
        ellipsis: true,
        width: 130,
        editable: false,
        render: (data) => {
          let card_src = data.card_type == 'visa' ? visa_card : master_card

          return (
            <div className={'flex align_center full_h'}>
              <img className={'card_type_img'} src={card_src} />

              {/*<CustomTooltip title={data.card_pan.replace(/(\w{4})(\w{4})(\w{4})(\w{4})/, "$1 $2 $3 $4")}>*/}
              <p>{data.card_number}</p>
              {/*</CustomTooltip>*/}
            </div>
          )
        },
      },
      {
        title: (
          <Form form={form}>
            <SearchableColumn
              divClass={'search_type_2'}
              title={t('businessCards.user')}
              name={'card_user' + ind}
              onChange={(event: any) => filterSubCard(event, 'card_user', ind)}
              form={form}
              filter={'searchfilter'}
            />
          </Form>
        ),
        dataIndex: 'col_3',
        key: 'col_3',
        className: ' col_3',
        ellipsis: true,
        width: 130,
        editable: false,
        render: (text) => {
          return <p>{text.card_owner}</p>
        },
      },
      {
        title: (
          <div className="sort_col">
            <Form form={form}>
              <SelectField
                placeholder={t('credits.creditStatus')}
                options={statusList}
                className="status-select"
                onChange={(event: any) =>
                  filterSubCard(event, 'status_filter', ind)
                }
                name={'status_filter' + ind}
                label
              />
            </Form>
          </div>
        ),
        dataIndex: 'col_4',
        key: 'col_4',
        className: 'col_4',
        ellipsis: true,
        width: 230,
        editable: false,
        render: (text) => {
          let p_classname = text.card_blocked
            ? 'has_blocked_amount'
            : 'no_blocked_amount'

          return (
            <>
              <p className={`other_color ${p_classname}`}>{text.card_status}</p>
              {text.card_blocked && (
                <CustomTooltip title={text.tooltip}>
                  <Button
                    className="has_blocked_data transparent"
                    icon={<InfoCircleOutlined />}
                  />
                </CustomTooltip>
              )}
            </>
          )
        },
      },
      {
        title: (
          <div className="finished_date sort_col">
            <SortableColumn
              data={tableData}
              setData={setTableData}
              dataOriginal={tableDataForSort}
              type={'date'}
              parameter={'col_5'}
              paramater_second={'card_expire_date'}
              dataIndex={ind}
            />
            <span>{t('salary.expiryDate')}</span>
          </div>
        ),
        dataIndex: 'col_5',
        key: 'col_5',
        className: 'col_5',
        ellipsis: true,
        width: 250,
        editable: false,
        render: (text) => {
          let expire_date = dateFormatter(
            text.card_expire_date,
            'MMMM DD, YYYY HH:mm:ss',
            'DD.MM.YYYY'
          )
          let p_class = ''

          if (new Date(expire_date) < new Date()) {
            p_class = ' card_expired other_color'
          } else if (
            parseInt(
              dateFormatter(text.card_expire_date, 'M', 'DD.MM.YYYY')
            ) ===
              new Date().getMonth() + 1 &&
            parseInt(
              dateFormatter(text.card_expire_date, 'YYYY', 'DD.MM.YYYY')
            ) === new Date().getFullYear()
          ) {
            p_class = ' card_expired_this_month other_color'
          }

          return <p className={` ${p_class}`}>{text.card_expire_date}</p>
        },
      },
      {
        title: (
          <div className="required-column">
            <span>{t('home.currency')}</span>
          </div>
        ),
        dataIndex: 'col_6',
        key: 'col_6',
        className: 'col_6',
        ellipsis: true,
        width: 209,
        editable: false,
        render: (text) => {
          return <p>{text.card_currency}</p>
        },
      },
      {
        title: (
          <div className="text-right">
            {t('businessCards.remainingMonthlyLimit')}
          </div>
        ),
        dataIndex: 'col_7',
        key: 'col_7',
        className: 'col_7',
        ellipsis: true,
        width: 100,
        editable: false,
        render: (text) => {
          let p_class =
            parseFloat(text.monthly_limit) > 0
              ? 'has_balance'
              : 'no_balance other_color'

          return (
            <>
              <p className={` is_blue ${p_class}`}>
                {text.monthly_limit}
                {text.has_info && (
                  <CustomTooltip title={text.has_info}>
                    <Button
                      className="has_blocked_data transparent"
                      icon={<InfoCircleOutlined />}
                    />
                  </CustomTooltip>
                )}
              </p>
            </>
          )
        },
      },
      {
        title: (
          <CustomTooltip title={'Bütün limitləri yenilə'}>
            <Button
              type={'ghost'}
              icon={<UpdateLimitIco />}
              onClick={() => {
                updateLimit('allLimit', recordData)
              }}
              className={'transparent'}
            />
          </CustomTooltip>
        ),
        dataIndex: 'col_8',
        key: 'col_8',
        className: 'col_8',
        ellipsis: true,
        width: 100,
        editable: false,
        render: (text, record) => (
          <CustomTooltip title={t('businessCards.updateLimit')}>
            <Button
              type={'ghost'}
              icon={<UpdateLimitIco />}
              onClick={() => {
                updateLimit(record.row)
              }}
              className={'transparent'}
            />
          </CustomTooltip>
        ),
      },
      {
        title: '',
        dataIndex: 'col_9',
        key: 'col_9',
        className: 'col_9',
        ellipsis: true,
        width: 100,
        editable: false,
        render: (text, record) => {
          return (
            <div className={'btn_box flex align_center justify_center'}>
              <Dropdown
                overlay={() => cardDropDown(record)}
                trigger={'click'}
                placement="bottomRight"
              >
                <Button
                  icon={<AccountMoreIco />}
                  onClick={(e) => {
                    setCardSelectedRow((old_data) => record)
                  }}
                  className="transparent table_more_btn"
                >
                  {
                    ability.can('view', 'NewIcon') && (<sup>
                      <div
                        style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          backgroundColor: '#F3646C',
                          marginLeft: '4px',
                        }}
                      ></div>
                    </sup>)
                  }
                </Button>
              </Dropdown>
            </div>
          )
        },
      },
    ]

    return {
      expandedRowRender: (record) => (
        <TableComponent
          columns={columns(record.ind, record)}
          data={record.data}
          scroll={{ x: true }}
          pagination={false}
          className=" transfer-table table-hover home_hesab_table  home_content_table  crk22 voen_cards_table_2 expanded_table"
        />
      ),
      rowExpandable: (record) => record.data,
      expandRowByClick: false,
      expandedRowKeys: expandedRowKeys,
    }
  }

  const updateAccountName = (e: any, row: any) => {
    let value = e.target.value.trim()
    let check_value =
      value.length > 0 ? value : '' /*getAccountType(row.ACCOUNT_TYPE)*/
    const requestData = {
      IBAN: row.subtitle,
      NICKNAME: check_value,
    }

    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    updateAccountNickname(requestData).then((res) => {
      if (
        res?.messages !== undefined &&
        res?.messages !== null &&
        res?.messages.length > 0 &&
        res?.messages[0].MESSAGE === 'SUCCESS'
      )
        updateData()
    })
  }

  const updateData = () => {
    getNewCards(getCurrentCompany()).then((res) => {
      setTableLoading({
        ...tableLoading,
        spinning: true,
      })

      let temp_array = []
      let filtereValueInitial = []
      // const data = await getNewCards(getCurrentCompany());

      const cards = res?.newBusinessCards?.MainCards
      props.updateNewCard(res)
      if (cards) {
        cards.map((row: any, i: number) => {
          filtereValueInitial.push({
            col_1: '',
            col_2: '',
            col_3: '',
            col_4: '',
          })
          let blocked_tooltip = `Kart ${row?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.`

          let tempRow = {
            ind: i,
            key: row.Iban,
            col_1: {
              title: row.nickName !== null ? row.nickName : row.Name,
              subtitle: row.Iban,
            },
            col_2: { card_count: row.AdditionNumb },
            col_3: { card_number: row.Iban },
            col_4: {
              card_status:
                row.IBANStat === 'Blocked' ? 'Bloklaşdırılıb' : 'Aktiv',
              card_blocked: row.IBANStat === 'Blocked',
              tooltip: blocked_tooltip,
            },
            col_5: { card_expire_date: row.OpenDate },
            col_6: { card_currency: row.Currency },
            col_7: { card_balance: '-' },
            row: { ...row, card_balance: '-' },
            data: [],
          }

          if (row.AdditionNumb > 0) {
            let subCards = []

            for (let subCard of row.AdditionCards) {
              subCards.push({
                key: subCard.Pan,
                col_1: {
                  title:
                    subCard.nickName !== null ? subCard.nickName : subCard.Name,
                  subtitle: subCard.Pan,
                },
                col_2: {
                  card_type: 'visa',
                  card_number: subCard.EncryptedPan,
                  card_pan: subCard.Pan,
                },
                col_3: { card_owner: subCard.CardHolder },
                col_4: {
                  card_status:
                    subCard.CardStat === 'Blocked' ? 'Bloklaşdırılıb' : 'Aktiv',
                  card_blocked: subCard.CardStat === 'Blocked',
                  CardStat: subCard.CardStat,
                },
                col_5: { card_expire_date: subCard.ExpDate },
                col_6: { card_currency: subCard.Currency },
                col_7: { monthly_limit: '-' },
                nickname: subCard.nickName,
                row: { ...subCard, monthly_limit: '-' },
              })
            }

            tempRow = { ...tempRow, data: subCards }
          }

          // @ts-ignore
          temp_array.push(tempRow)
        })
      }

      setTableLoading({
        ...tableLoading,
        spinning: false,
      })
      setTableData((old_data) => temp_array)
      setTableDataMain((old_data) => temp_array)
      setTableDataForSort((old_data) => temp_array)

      setFilteredValuesSubCard(filtereValueInitial)
    })
  }

  const fetchData = async () => {
    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    let temp_array = []
    let filtereValueInitial = []
    // const data = await getNewCards(getCurrentCompany());

    const cards = props.newBusinessCardsData?.newBusinessCards?.MainCards
    let encryptedPanList = []
    let hasSubCardList = []
    if (cards) {
      // setTableLoading({
      //     ...tableLoading,
      //     spinning: true
      // });
      for (let row of cards) {
        let EncryptedPan = row.AdditionCards[0].EncryptedPan

        if (EncryptedPan !== undefined) {
          encryptedPanList.push(EncryptedPan)
          hasSubCardList.push({
            Iban: row.AdditionCards[0].Iban,
            Pan: row.AdditionCards[0].Pan,
          })
        }
      }
      let req_data = {
        encryptedPanList: encryptedPanList,
      }
      const get_card_balance = await getNewCardBalance(
        getCurrentCompany(),
        req_data
      )

      cards.map((row: any, i: number) => {
        filtereValueInitial.push({ col_1: '', col_2: '', col_3: '', col_4: '' })
        let blocked_tooltip = `Kart ${row?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.`
        let getBalance =
          get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(
            (bRow) => bRow.Pan === row.AdditionCards[0].Pan
          )
        let tempRow = {
          ind: i,
          key: row.Iban,
          col_1: {
            title: row.nickName !== null ? row.nickName : row.Name,
            subtitle: row.Iban,
          },
          col_2: { card_count: row.AdditionNumb },
          col_3: { card_number: row.Iban },
          col_4: {
            card_status:
              row.IBANStat === 'Blocked'
                ? t('home.blocked')
                : t('salary.active'),
            card_blocked: row.IBANStat === 'Blocked',
            tooltip: blocked_tooltip,
          },
          col_5: { card_expire_date: row.OpenDate },
          col_6: { card_currency: row.Currency },
          col_7: { card_balance: financial(getBalance?.Balance) },
          row: { ...row, card_balance: '-' },
          data: [],
        }

        if (row.AdditionNumb > 0) {
          let subCards = []

          for (let subCard of row.AdditionCards) {
            subCards.push({
              key: subCard.Pan,
              col_1: {
                title:
                  subCard.nickName !== null ? subCard.nickName : subCard.Name,
                subtitle: subCard.Pan,
              },
              col_2: {
                card_type: 'visa',
                card_number: subCard.EncryptedPan,
                card_pan: subCard.Pan,
              },
              col_3: { card_owner: subCard.CardHolder },
              col_4: {
                card_status:
                  subCard.CardStat === 'Blocked'
                    ? t('home.blocked')
                    : t('salary.active'),
                card_blocked: subCard.CardStat === 'Blocked',
                CardStat: subCard.CardStat,
              },
              col_5: { card_expire_date: subCard.ExpDate },
              col_6: { card_currency: subCard.Currency },
              col_7: { monthly_limit: '-' },
              nickname: subCard.nickName,
              row: { ...subCard, monthly_limit: '-' },
            })
          }

          tempRow = { ...tempRow, data: subCards }
        }

        // @ts-ignore
        temp_array.push(tempRow)
      })
    }

    setTableData((old_data) => temp_array)
    setTableDataMain((old_data) => temp_array)
    setTableDataForSort((old_data) => temp_array)

    setFilteredValuesSubCard(filtereValueInitial)

    setTableLoading({
      ...tableLoading,
      spinning: false,
    })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const updateLimit = async (parentRow: any = null, recordData: any = null) => {
    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    let encryptedPanList = []
    let hasSubCardList = []

    if (parentRow == 'allLimit') {
      let AdditionCards = recordData.row.AdditionCards

      for (let card of AdditionCards) {
        let EncryptedPan = card.EncryptedPan

        if (EncryptedPan !== undefined) {
          encryptedPanList.push(EncryptedPan)
          hasSubCardList.push({
            Iban: recordData.row.Iban,
            Pan: card.Pan,
          })
        }
      }
    } else {
      encryptedPanList.push(parentRow.EncryptedPan)
    }

    let req_data = {
      encryptedPanList: encryptedPanList,
    }

    const get_sub_card_limit = await getNewCardLimit(
      getCurrentCompany(),
      req_data
    )

    let new_array = tableData?.map((row) => {
      let sub_data = row.data

      let new_data = sub_data?.map((sub_row) => {
        let limit = sub_row.col_7.monthly_limit

        if (parentRow === 'allLimit') {
          let findCurrentRowBalance = hasSubCardList?.find(
            (cRow) => cRow.Pan === sub_row.row.Pan
          )

          if (findCurrentRowBalance !== undefined) {
            let getBalance =
              get_sub_card_limit?.businessCardsLimit?.CardInfoResponses?.find(
                (bRow) => bRow.Pan === findCurrentRowBalance.Pan
              )

            limit = financial(getBalance?.ResidualAmount)
          }
        }

        let limit_row =
          parentRow !== 'allLimit' && sub_row.row.Pan === parentRow?.Pan
            ? financial(
                get_sub_card_limit?.businessCardsLimit?.CardInfoResponses[0]
                  ?.ResidualAmount
              )
            : limit

        return {
          ...sub_row,
          row: { ...sub_row.row, monthly_limit: limit_row },
          col_7: { monthly_limit: limit_row },
        }
      })

      return {
        ...row,
        data: new_data,
      }
    })

    let new_arrayMain = tableDataMain?.map((row) => {
      let sub_data = row.data

      let new_data = sub_data?.map((sub_row) => {
        let limit = sub_row.col_7.monthly_limit

        if (parentRow === 'allLimit') {
          let findCurrentRowBalance = hasSubCardList?.find(
            (cRow) => cRow.Pan === sub_row.row.Pan
          )

          if (findCurrentRowBalance !== undefined) {
            let getBalance =
              get_sub_card_limit?.businessCardsLimit?.CardInfoResponses?.find(
                (bRow) => bRow.Pan === findCurrentRowBalance.Pan
              )

            limit = financial(getBalance?.ResidualAmount)
          }
        }

        let limit_row =
          parentRow !== 'allLimit' && sub_row.row.Pan === parentRow?.Pan
            ? financial(
                get_sub_card_limit?.businessCardsLimit?.CardInfoResponses[0]
                  ?.ResidualAmount
              )
            : limit

        return {
          ...sub_row,
          row: { ...sub_row.row, monthly_limit: limit_row },
          col_7: { monthly_limit: limit_row },
        }
      })

      return {
        ...row,
        data: new_data,
      }
    })

    setTableData((old_data) => new_array)
    setTableDataMain((old_data) => new_arrayMain)
    setTableDataForSort((old_data) => new_array)

    setTableLoading({
      ...tableLoading,
      spinning: false,
    })
  }

  const updateBalance = async (parentRow: any = null) => {
    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    let encryptedPanList = []
    let hasSubCardList = []

    if (parentRow === 'allBalance') {
      for (let row of tableData) {
        let EncryptedPan = row.row.AdditionCards[0].EncryptedPan

        if (EncryptedPan !== undefined) {
          encryptedPanList.push(EncryptedPan)
          hasSubCardList.push({
            Iban: row.row.AdditionCards[0].Iban,
            Pan: row.row.AdditionCards[0].Pan,
          })
        }
      }
    } else {
      encryptedPanList.push(parentRow.AdditionCards[0].EncryptedPan)
    }

    let req_data = {
      encryptedPanList: encryptedPanList,
    }

    const get_card_balance = await getNewCardBalance(
      getCurrentCompany(),
      req_data
    )

    let new_array = tableData?.map((row) => {
      let balance = row.col_7.card_balance

      if (parentRow === 'allBalance') {
        let findCurrentRowBalance = hasSubCardList?.find(
          (cRow) => cRow.Pan === row.row.AdditionCards[0].Pan
        )

        if (findCurrentRowBalance !== undefined) {
          let getBalance =
            get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(
              (bRow) => bRow.Pan === findCurrentRowBalance.Pan
            )

          balance = financial(getBalance?.Balance)
        }
      }

      return {
        ...row,
        col_7: {
          card_balance:
            parentRow !== 'allBalance' && row.row.Iban === parentRow.Iban
              ? financial(
                  get_card_balance?.businessCardsBalance?.CardInfoResponses[0]
                    ?.Balance
                )
              : balance,
        },
      }
    })

    setTableData((old_data) => new_array)
    setTableDataMain((old_data) => new_array)
    setTableDataForSort((old_data) => new_array)

    setTableLoading({
      ...tableLoading,
      spinning: false,
    })
  }

  const filterSubCard = (e: any, column: string, ind: any) => {
    let newfiltereValuesCard = filtereValuesSubCard

    if (column === 'card_name') {
      newfiltereValuesCard[ind].col_1 = e.target.value?.toLowerCase()
      setFilteredValuesSubCard(newfiltereValuesCard)
    }

    if (column === 'card_pan') {
      newfiltereValuesCard[ind].col_2 = e.target.value?.toLowerCase()
      setFilteredValuesSubCard(newfiltereValuesCard)
    }

    if (column === 'card_user') {
      newfiltereValuesCard[ind].col_3 = e.target.value?.toLowerCase()
      setFilteredValuesSubCard(newfiltereValuesCard)
    }

    if (column === 'status_filter') {
      newfiltereValuesCard[ind].col_4 = e?.toLowerCase()
      setFilteredValuesSubCard(newfiltereValuesCard)
    }

    if (tableDataMain && filtereValuesSubCard) {
      let new_array = []

      tableDataMain?.map((row: any, i: number) => {
        let AdditionCards = row.row.AdditionCards
        let data = row.data

        if (AdditionCards.length > 0) {
          let filterAdditionCards = AdditionCards
          let filterData = data

          filterAdditionCards = filterAdditionCards.filter(
            (sRow) =>
              sRow.Name?.toLowerCase()
                .normalize()
                .replace(/[\u0300-\u036f]/g, '')
                .includes(filtereValuesSubCard[i]['col_1']) &&
              sRow.EncryptedPan.normalize()
                .replace(/[\u0300-\u036f]/g, '')
                .includes(filtereValuesSubCard[i]['col_2']) &&
              (sRow.CardHolder
                ? sRow.CardHolder?.toLowerCase()
                    .normalize()
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(filtereValuesSubCard[i]['col_3'])
                : sRow.CardHolder === null) &&
              sRow.CardStat?.toLowerCase().includes(
                filtereValuesSubCard[i]['col_4']
              )
          )

          filterData = filterData.filter(
            (sRow) =>
              sRow.col_1.title
                ?.toLowerCase()
                .normalize()
                .replace(/[\u0300-\u036f]/g, '')
                .includes(filtereValuesSubCard[i]['col_1']) &&
              sRow.col_2.card_number
                .normalize()
                .replace(/[\u0300-\u036f]/g, '')
                .includes(filtereValuesSubCard[i]['col_2']) &&
              (sRow.col_3.card_owner
                ? sRow.col_3.card_owner
                    ?.toLowerCase()
                    .normalize()
                    .replace(/[\u0300-\u036f]/g, '')
                    .includes(filtereValuesSubCard[i]['col_3'])
                : sRow.col_3.card_owner === null) &&
              sRow.col_4.CardStat?.toLowerCase().includes(
                filtereValuesSubCard[i]['col_4']
              )
          )

          new_array.push({
            ...row,
            data: filterData,
            row: { ...row.row, AdditionCards: filterAdditionCards },
          })
        } else {
          new_array.push(row)
        }
      })

      setTableData((old_data) => new_array)
      setTableDataForSort((old_data) => new_array)
      if (filtereValuesSubCard[ind]['col_4'] === 'all') {
        form.resetFields(['status_filter' + ind])
      }
    }
  }

  const modalDataRequisite = () => {
    return requisiteData?.rekvizitAzn &&
      requisiteData?.rekvizitAzn[0]?.ccyType === 'AZN'
      ? {
          modalTitle: `${t('requisites.accountDetails')}: ${
            titleRequisiteState[0] ?? ''
          } ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
          groups: [
            {
              title: t('requisites.bankAccountDetails'),
              tableHasBorderBottom: false,
              data: [
                {
                  label: t('requisites.customer'),
                  value: requisiteData?.customerName ?? '',
                },
                {
                  label: t('requisites.legalAddress'),
                  value: requisiteData?.customerAddress ?? '',
                },
                {
                  label: t('requisites.customerBank'),
                  value: requisiteData?.bankName ?? '',
                },
                {
                  label: t('requisites.taxID'),
                  value: requisiteData?.bankVoen ?? '',
                },
                {
                  label: t('requisites.legalAddress'),
                  value: requisiteData?.bankAddress ?? '',
                },
                {
                  label: t('requisites.phone'),
                  value: requisiteData?.bankPhone ?? '',
                },
                {
                  label: t('requisites.email'),
                  value: requisiteData?.bankEmail ?? '',
                },
              ],
            },
            {
              title: t('requisites.beneficiary'),
              tableHasBorderBottom: false,
              tableHasMarginBottom: true,
              currency: titleRequisiteState[2] ?? '',
              data: [
                {
                  label: t('requisites.name'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.customerName
                    : '',
                },
                {
                  label: t('requisites.taxID'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.customerVoen
                    : '',
                },
                {
                  label: 'IBAN',
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.iban
                    : '',
                },
              ],
            },
            {
              title: t('requisites.beneficiaryBank'),
              tableHasBorderBottom: false,
              tableHasMarginBottom: true,
              data: [
                {
                  label: t('requisites.name'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.bankName
                    : '',
                },
                {
                  label: t('requisites.code'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.bankCode
                    : '',
                },
                {
                  label: t('requisites.mH'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.bankAccount
                    : '',
                },
                {
                  label: 'SWIFT',
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.bankSwift
                    : '',
                },
              ],
            },
          ],
          buttons: [{ selectAccount: true }],
        }
      : {
          modalTitle: `${t('requisites.accountDetails')}: ${
            titleRequisiteState[0] ?? ''
          } ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
          groups: [
            {
              title: t('requisites.bankAccountDetails'),
              tableHasBorderBottom: false,
              data: [
                {
                  label: t('requisites.customer'),
                  value: requisiteData?.customerName ?? '',
                },
                {
                  label: t('requisites.legalAddress'),
                  value: requisiteData?.customerAddress ?? '',
                },
                {
                  label: t('requisites.customerBank'),
                  value: requisiteData?.bankName ?? '',
                },
                {
                  label: t('requisites.taxID'),
                  value: requisiteData?.bankVoen ?? '',
                },
                {
                  label: t('requisites.legalAddress'),
                  value: requisiteData?.bankAddress ?? '',
                },
                {
                  label: t('requisites.phone'),
                  value: requisiteData?.bankPhone ?? '',
                },
                {
                  label: t('requisites.email'),
                  value: requisiteData?.bankEmail ?? '',
                },
              ],
            },
            {
              title: t('requisites.beneficiary'),
              tableHasBorderBottom: false,
              tableHasMarginBottom: true,
              currency: titleRequisiteState[2] ?? '',
              data: [
                {
                  label: t('requisites.name'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.customerName
                    : '',
                },
                {
                  label: t('requisites.taxID'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.customerVoen
                    : '',
                },
                {
                  label: 'IBAN',
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.iban
                    : '',
                },
              ],
            },
            {
              title: t('requisites.beneficiaryBank'),
              tableHasBorderBottom: false,
              tableHasMarginBottom: true,
              data: [
                {
                  label: t('requisites.name'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.bankName
                    : '',
                },
                {
                  label: t('transfers.address'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.bankAddress
                    : '',
                },
                {
                  label: 'SWIFT',
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.bankSwift
                    : '',
                },
              ],
            },
            {
              title: t('newTransfer.intermediaryBank'),
              tableHasBorderBottom: false,
              tableHasMarginBottom: true,
              data: [
                {
                  label: t('requisites.name'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.muhbirName
                    : '',
                },
                {
                  label: t('transfers.address'),
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.muhbirAddress
                    : '',
                },
                {
                  label: 'SWIFT',
                  value: requisiteData?.rekvizitAzn
                    ? requisiteData?.rekvizitAzn[0]?.muhbirSwift
                    : '',
                },
              ],
            },
          ],
          buttons: [{ selectAccount: true }],
        }
  }

  return (
    <>
      <Form form={form}>
        {tableDataMain?.length > 0 && (
          <TableComponent
            loading={tableLoading}
            columns={accountTableColumns}
            className=" transfer-table table-hover home_hesab_table home_content_table business_cards_table voen_cards_table voen_cards_table_2"
            data={tableData}
            scroll={{ x: true }}
            pagination={false}
            pageSize={3}
            position={'center'}
            alignment={'bottom'}
            expandable={expandedRowRender()}
            rowClassName={(record, index) =>
              expandedRowKeys.indexOf(record.key) !== -1 ? ' opened_row ' : ''
            }
          />
        )}

        {tableDataMain?.length === 0 && (
          <div className={'full flex justify_center table_no_data flex_wrap'}>
            <h3>{t('businessCards.noBusinessCard')}</h3>
          </div>
        )}
      </Form>

      {visibleBlockUnblockCardModal && (
        <EnableOrDisableServiceModal
          visible={visibleBlockUnblockCardModal}
          onClose={setVisibleBlockUnblockCardModal}
          serviceType={'activate'}
          activateBtnText={t('businessCards.blockCard')}
          modalTitle={t('businessCards.blockCard')}
          modalText={t('businessCards.noOperationNotif')}
          successModalTitle={t('businessCards.isReady')}
          successModalText={t('businessCards.cardBlocked')}
        />
      )}

      {visibleResetPinModal && (
        <EnableOrDisableServiceModal
          visible={visibleResetPinModal}
          onClose={setVisibleResetPinModal}
          serviceType={'activate'}
          activateBtnText={t('businessCards.reset')}
          modalTitle={t('businessCards.resetPINEntryAttempt')}
          modalText={t('businessCards.attemptInfo')}
          successModalTitle={t('businessCards.isReady')}
          successModalText={t('businessCards.resetedPINEntryAttempt')}
        />
      )}

      {visibleSmsNotifModal && (
        <EnableOrDisableServiceModal
          visible={visibleSmsNotifModal}
          onClose={setVisibleSmsNotifModal}
          serviceType={'activate'}
          modalTitle={t('notification.attention')}
          modalText={t('businessCards.SMSNotificationVOENInfo')}
          successModalTitle={t('businessCards.isReady')}
          successModalText={t('businessCards.SMSNotificationActivated')}
        />
      )}

      <NextModal
        // btnType={'APPROVE'}
        // requestType={requestType}
        // disabledSign={props.disabledSign}
        // onStatusChange={props.handleStatusChange}
        // nextModalText={'Köçürmələr qrupu banka göndərilir. Nəticəni “Köçürmələr”də izləyə bilərsiniz.'}
        // callBackApi={newTransferFunc}
        visible={requisiteModalVisible}
        data={modalDataRequisite()}
        // // tableTitle ={props.type == 'common' ? '' : t("transfers.transferHistory") }
        // columnsData={columnsData}
        // tableData={props.tableData['SIGN_DETAIL']}
        // type={props.type}
        onClose={handleModalClose}
        // innerColumnsdata={innerColumnsdata}
        // innerrtableData={props.innerrtableData}
        // transferData={props.type == 'common' ? false : true}
        className={'flex_middle'}
        source={'requiste'}
        otherButtons={footerBtnsSecondModal}
      />
      <Modal
        open={openModal}
        closeIcon={<ModalCloseIco />}
        title={isError ? t('common.attention') :  t('businessCards.limits')}
        centered
        destroyOnClose
        width={(isFetching || isError) ? 500 : 1400} 
        footer={null}
        onCancel={() => setOpenModal(false)}
        afterClose={() => {
          // resetEmployeePan()
          dispatch(limitsCardApi.util.resetApiState())
        }}
      >
         {
        isError ?   
          <CustomResult
        icon={<ModalErrorIco />}
        text={error?.data}
        buttons={[
          {
            label: t('common.close'),
            type: 'primary',
            onClick: ()=>{setOpenModal(false)},
          }
        ]}
      /> :  <LimitsModalMain />
       }
      </Modal>
      <Modal
        open={openBlockedModal}
        closeIcon={<ModalCloseIco />}
        title={isError ? t('common.attention') :  t('businessCards.blockCard')}
        centered
        width={(isFetching || isError) ? 500 : 650} 
        footer={null}
        destroyOnClose
        afterClose={() => {
          // resetEmployeePan()
          dispatch(limitsCardApi.util.resetApiState())
        }
        }
        onCancel={() => setOpenBlockedModal(false)}
      >
       {
        isError ?   
          <CustomResult
        icon={<ModalErrorIco />}
        text={error?.data}
        buttons={[
          {
            label: t('common.close'),
            type: 'primary',
            onClick: ()=>{setOpenBlockedModal(false)},
          }
        ]}
      /> : <BlockedCardSwitch />
       }
      </Modal>

      {tableLoading.spinning && <FullScreenLoading />}
    </>
  )
}
const mapDispatchToProps = {
  getBlockedIbanData,
  getAccountsData,
  setMoreDetail,
  setIbanNumber,
  getRequisiteData,
}

const mapStateToProps = (state: any) => ({
  requisiteData: state.accountsStatement.requisiteData.result ?? [],
})
export default connect(mapStateToProps, mapDispatchToProps)(VoenCard)
